import {Injectable} from '@angular/core';

@Injectable()
export class LocalePtBr {
    firstDayOfWeek = 0;
    dayNames = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
    dayNamesShort =  ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'];
    dayNamesMin =  ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'];
    monthNames =  [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto',
      'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];
    monthNamesShort =  ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    today =  'Hoje';
    clear =  'Limpar';
}
